import { inject } from '@angular/core';
import {
  HttpErrorResponse,
  HttpHeaders,
  HttpInterceptorFn
} from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Location } from '@angular/common';
import { RouteService } from '@helpers/routing/router.service';
import { APP_CONFIG, AppConfig } from '@cfg/env/app.config';
import { JwtTokenService } from './jwt-token.service';
/**
 * Interceptor HTTP cuya responsabilidad es controlar la autorización y autenticacion global de peticiones hacia el backend
 */
export const securityInterceptRequestService: HttpInterceptorFn = (
  req,
  next
) => {
  const appConfig: AppConfig = inject(APP_CONFIG);
  const router = inject(RouteService);
  const location = inject(Location);
  const jwtService = inject(JwtTokenService);

  let headers = new HttpHeaders({ 'X-APP-RELAYSTATE': location.path() });

  // Obtener el token JWT y verificar expiración
  const token = jwtService.getToken();
  if (token) {
    if (!jwtService.isTokenExpired(token)) {
      console.log('🔐 Inyectando JWT Token en Authorization header');
      headers = headers.append('Authorization', `Bearer ${token}`);
    } else {
      console.warn('⏰ Token JWT ha expirado, limpiando cookies');
      jwtService.clearToken();
    }
  } else {
    console.log('⚠️ No se encontró token JWT en cookies');
  }

  // Agregar Auth Basic usando configuración desde appConfig
  /*const credentials = `${appConfig.authBasic.username}:${appConfig.authBasic.password}`;
  const authToken = btoa(credentials); // Base64 encode de las credenciales
  headers = headers.append('Authorization', `Basic ${authToken}`);*/

  // Verificar si el cuerpo de la solicitud es FormData
  if (!(req.body instanceof FormData)) {
    // Si no es FormData, usa 'application/json'
    headers = headers.append('Content-Type', 'application/json');
  }

  const reqWithHeaders = req.clone({ withCredentials: true, headers });

  return next(reqWithHeaders).pipe(
    catchError((err: HttpErrorResponse) => {
      switch (err.status) {
        case 401:
          //  Presenta la pagina de login desde seus
          router.replaceWith(err.error as string);
          return throwError(() => err);
        case 403:
          router.navigateTo('/access-denied');
          return throwError(() => err);
        default:
          return throwError(() => err);
      }
    })
  );
};
